import { Component, EventEmitter, Output } from "@angular/core";
import { Observable } from "rxjs";
import { Supplier } from "src/app/inventory/supplier/supplier";
import { SupplierService } from "src/app/inventory/supplier/supplier.service";
import { Page } from "src/app/util/page";
import { Criteria } from "src/app/util/search/criteria/criteria";
import { SearchComponent } from "src/app/util/search/search-component";
import { SearchRequest } from "src/app/util/search/search-request";

@Component({
  selector: "./select-supplier",
  styleUrls: ["./select-supplier.component.css"],
  templateUrl: "./select-supplier.component.html"
})
export class SelectSupplierComponent extends SearchComponent<Supplier> {

  @Output()
  private supplierChange = new EventEmitter<Supplier>();

  selectedSupplier!: Supplier;

  constructor(
    private supplierService: SupplierService) {
      super(new Map<string, Criteria>());

      this.refresh();
    }

  public onSearch(searchRequest: SearchRequest, page: number): Observable<Page<Supplier>> {
    return this.supplierService.findAll({
      name: searchRequest.query,
    }, page, 50);
  }

  public refresh(): void {
    this.search();
  }

  selectSupplier(supplier: Supplier) {
    this.selectedSupplier = supplier;

    this.supplierChange.emit(supplier);
  }
}